import request from '@/api/request' // 确保路径正确，指向你的 request.js

export default {
    login(data) {
        return request({
            url: '/login/account',
            method: 'post',
            params: data
        })
    },

}